import React, { useState } from 'react';
// import IconLocation from '../../assets/icons/gps.svg';
// import IconLocationWhite from '../../assets/icons/gps-white.svg';
// import IconLocationBlack from '../../assets/icons/gps-black.svg';
import { Cinemas } from '../Cinemas';
import styles from './LocationOptions.module.scss';

const LocationOptions = (props) => {
  const { 
    cinemas,
    setFilter,
    isPopup,
    homeURL,
    useSiteAsFilter,
    setActiveTab,
    colorScheme,
    showSearch,
    concessionBtnText,
    concessionSiteLink,
    concessionLinkNewTab,
    concessionEnabledParam,
    testCinemasEnabled
  } = props;

  const [useCurrentLocation, setUseCurrentLocation] = useState(false);
  const [location, setLocation] = useState('');

  const handleLocationChange = (e) => {
    setLocation(e.target.value);
  }

  const handleLocationFieldFocus = (e) => {
    setUseCurrentLocation(false);
  }

  // const handleCurrentLocationButton = () => {
  //   if (!useCurrentLocation) {
  //     setLocation('');
  //   }

  //   setUseCurrentLocation(!useCurrentLocation);
  // }

  // const colorIcon = colorScheme === 'light' ? IconLocationBlack : IconLocationWhite;

  return (
    <React.Fragment>
      {
        showSearch &&
        <div className={styles.locationOptions}>
          {/*
            <div className={"button " + styles.buttonCurrentLocation + (useCurrentLocation ? (' ' + styles.active) : '')} onClick={handleCurrentLocationButton}>
              <img src={(useCurrentLocation ? IconLocation : colorIcon)} alt="" />
              {window.mapiTranslations['Use Current Location']}
            </div>

            <span>{window.mapiTranslations['or']}</span> 
          */}

          <label for="field-location">
            {window.mapiTranslations['Show only cinemas around'] || 'Show only cinemas around'}
          </label>

          <input 
            type="text" 
            className={styles.fieldLocation}
            id="field-location" 
            name="field-location" 
            placeholder={window.mapiTranslations['City or Postal Code'] || 'City or Postal Code'} 
            value={location} 
            onChange={handleLocationChange}
            onFocus={handleLocationFieldFocus}
          />
        </div>
      }
      
      {/* <hr /> */}

      <Cinemas 
        location={location} 
        useCurrentLocation={useCurrentLocation} 
        cinemas={cinemas} 
        setFilter={setFilter}
        isPopup={isPopup}
        homeURL={homeURL}
        useSiteAsFilter={useSiteAsFilter}
        setActiveTab={setActiveTab}
        colorScheme={colorScheme}
        concessionBtnText={concessionBtnText}
        concessionSiteLink={concessionSiteLink}
        concessionLinkNewTab={concessionLinkNewTab}
        concessionEnabledParam={concessionEnabledParam}
        testCinemasEnabled={testCinemasEnabled} 
      />
    </React.Fragment>
  );
}

export { LocationOptions }
